<script setup lang="ts">
const emit = defineEmits(["close"]);
const props = defineProps({
  isReturningUser: {
    type: Boolean,
    default: false,
  },
});

onUnmounted(() => {
  const router = useRouter();
  router.replace({ query: {} });
});
</script>
<template>
  <div>
    <div class="flex flex-col items-center gap-3 max-w-sm mx-auto mb-8">
      <BaseIcon
        :name="'checkmark_green'"
        class="text-success-300 mt-7 mb-5 mx-auto w-20 h-20" />
      <p
        class="text-neutral-200 font-bold text-xl text-center"
        data-test="wallet-created-successfully">
        {{ $t("main.walletLock.walletUnlocked") }}
      </p>
      <p class="text-neutral-300 text-center">
        {{ $t("main.walletLock.walletSuccessfullyUnlocked") }}
      </p>
      <div
        v-if="!props.isReturningUser"
        class="max-w-sm bg-primary-900 rounded-sm flex items-center gap-3 py-2 pl-3 pr-4">
        <BaseIcon name="GFAL_token" alt="Games for a Living" class="w-8 h-8" />
        <i18n-t
          tag="p"
          class="text-primary-400 text-sm"
          keypath="main.modalWalletCreationSuccess.walletAcceptanceNote"
          scope="global">
          <template #GFAL>
            <span class="font-bold">{{
              $t("main.modalWalletCreationSuccess.GFAL")
            }}</span>
          </template>
        </i18n-t>
      </div>
    </div>
    <div class="mt-5 mb-2 sm:mt-6 flex">
      <BaseButtonSubmit
        :text="$t('main.modalWalletCreationSuccess.close')"
        data-test="button-close-modal-wallet-creation-success"
        size="long"
        class="mx-auto"
        @click="emit('close')" />
    </div>
  </div>
</template>
